// @flow

const packageJson = require("../../package.json");

export const VERSION_SHORT: string = `v${packageJson.version}`;
